"use client"

import React, { useState, useEffect } from 'react';
import { CheckCircle, Home, ArrowLeft, Sparkles, Mail } from 'lucide-react';
import Script from 'next/script';

export default function ThankYouPage() {
  const [isVisible, setIsVisible] = useState(false);
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    setIsVisible(true);

    // Generate floating particles
    const newParticles = Array.from({ length: 20 }, (_, i) => ({
      id: i,
      left: Math.random() * 100,
      animationDelay: Math.random() * 3,
      size: Math.random() * 8 + 4,
    }));
    setParticles(newParticles);
  }, []);

  const handleHomeClick = () => {
    // In Next.js, you would use: router.push('/') or window.location.href = '/'
    window.location.href = '/';
  };

  const handleBackClick = () => {
    // In Next.js, you would use: router.back() or window.history.back()
    window.history.back();
  };

  return (

   <>

        <div className="min-h-screen pt-20 bg-gradient-to-br from-indigo-50 via-white to-purple-50 relative overflow-hidden">
          {/* Animated background particles */}
          <div className="absolute inset-0 overflow-hidden pointer-events-none">
            {particles.map((particle) => (
              <div
                key={particle.id}
                className="absolute animate-bounce opacity-20"
                style={{
                  left: `${particle.left}%`,
                  animationDelay: `${particle.animationDelay}s`,
                  animationDuration: '3s',
                  top: `${Math.random() * 100}%`,
                }}
              >
                <Sparkles
                  size={particle.size}
                  className="text-indigo-400"
                />
              </div>
            ))}
          </div>

          {/* Gradient orbs */}
          <div className="absolute top-20 left-20 w-72 h-72 bg-gradient-to-r from-purple-400 to-pink-400 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse"></div>
          <div className="absolute bottom-20 right-20 w-72 h-72 bg-gradient-to-r from-yellow-400 to-red-400 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse" style={{ animationDelay: '1s' }}></div>
          {/* <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-72 h-72 bg-gradient-to-r from-blue-400 to-indigo-400 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse" style={{animationDelay: '2s'}}></div> */}

          {/* Main content */}
          <div className="relative z-10 flex items-center justify-center min-h-screen p-4">
            <div className={`max-w-md w-full text-center transform transition-all duration-1000 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
              }`}>

              {/* Success icon with animation */}
              <div className="relative mb-8">
                <div className="mx-auto w-24 h-24 bg-gradient-to-r from-green-400 to-emerald-500 rounded-full flex items-center justify-center shadow-2xl animate-bounce">
                  <CheckCircle size={48} className="text-white" />
                </div>
                <div className="absolute inset-0 w-24 h-24 mx-auto bg-gradient-to-r from-green-400 to-emerald-500 rounded-full animate-ping opacity-20"></div>
              </div>

              {/* Main message */}
              <div className="my-10 space-y-4">
                <h1 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-gray-800 to-gray-600 bg-clip-text text-transparent leading-tight">
                  Thank You!
                </h1>
                <div className="flex items-center justify-center mb-4">
                  <Mail className="text-indigo-500 mr-2" size={20} />
                  <p className="text-lg text-gray-600 font-medium">
                    Message Sent Successfully
                  </p>
                </div>
                <p className="text-gray-500 leading-relaxed max-w-sm mx-auto">
                  We've received your message and will get back to you as soon as possible.
                  We appreciate you reaching out to us!
                </p>
              </div>

              {/* Action buttons */}
              <div className="space-y-4">
                <button
                  onClick={handleHomeClick}
                  className="w-full bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white font-semibold py-4 px-8 rounded-2xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 flex items-center justify-center space-x-2 group"
                >
                  <Home size={20} className="group-hover:animate-pulse" />
                  <span>Back to Home</span>
                </button>

                <button
                  onClick={handleBackClick}
                  className="w-full bg-white hover:bg-gray-50 text-gray-700 font-semibold py-4 px-8 rounded-2xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 flex items-center justify-center space-x-2 border border-gray-200 group"
                >
                  <ArrowLeft size={20} className="group-hover:animate-pulse" />
                  <span>Go Back</span>
                </button>
              </div>

              {/* Additional info */}
              <div className="mt-8 p-4 bg-white/50 backdrop-blur-sm rounded-2xl border border-white/20 shadow-lg">
                <p className="text-sm text-gray-600">
                  <span className="font-semibold text-indigo-600">Response Time:</span> Usually within 24 hours
                </p>
              </div>
            </div>
          </div>

          {/* Floating animation styles */}
          <style jsx>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-20px); }
        }
        .animate-float {
          animation: float 6s ease-in-out infinite;
        }
      `}</style>
        </div>

    </>
  );
}
